import React from "react"

import { PrimitiveText } from "@/primitives/PrimitiveText"
import { DisplayTextProps } from "@/components/Text/protocols"

import { SxProps, Theme } from "@mui/material"

import useStyles from "@/components/Text/Display/styles"
import { FONT } from "@/styles/fonts"

export const Display = (props: DisplayTextProps) => {
	const {
		color,
		children,
		type,
		textTransform = "none",
		fontWeight = "regular",
		gutterBottom = false,
		sx
	} = props

	const classes = useStyles()

	const getDisplayStyle = () => {
		const displayTypeToDisplayStyle: Record<DisplayTextProps["type"], SxProps<Theme>> = {
			display1: classes.display1,
			display2: classes.display2
		}

		const displayStyle = displayTypeToDisplayStyle[type]

		return displayStyle
	}

	return (
		<PrimitiveText
			sx={[{ color: color, fontWeight: FONT.fontWeight[fontWeight] }, getDisplayStyle(), ...(Array.isArray(sx) ? sx : sx ? [sx] : [])] as SxProps<Theme>}
			textTransform={textTransform}
			gutterBottom={gutterBottom}
		>
			{children}
		</PrimitiveText>
	)
}